var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(!_vm.session)?_c('component-home'):_vm._e(),(_vm.session)?_c('dashboard'):_vm._e(),(_vm.session)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }